import type { WarrantyCoverage } from '@/services/dashboardApi'

/** La alerta solo se muestra si el vertical vende productos y hay productos sin garantía configurada. */
export function shouldShowWarrantyAlert(coverage: WarrantyCoverage | undefined): coverage is WarrantyCoverage {
  return Boolean(coverage?.applies && coverage.productsWithoutWarranty > 0)
}

export function buildWarrantyAlertCopy(coverage: WarrantyCoverage): { title: string; body: string } {
  const count = coverage.productsWithoutWarranty
  const title =
    count === 1
      ? '1 producto no tiene su garantía configurada'
      : `${count} productos no tienen su garantía configurada`
  const fallback = coverage.hasGeneralPolicy
    ? 'Mientras tanto, el asistente usa tu política general de garantía.'
    : 'Define también una política general de garantía: el asistente la usará como respaldo mientras tanto.'
  return {
    title,
    body: `Para mejorar la experiencia de tus clientes, indica en cada producto si tiene garantía de la tienda, del fabricante o si no la tiene (por ejemplo, los consumibles). ${fallback}`,
  }
}
